import Main from "../components/layout/Main";
import ProtectedRoute from "../components/comps/protected_route";
import ParentFinancePortal from "../pages/parent/ParentFinancePortal";

const parentRoutes = [
  {
    path: "/parent",
    element: (
      <ProtectedRoute>
        <Main />
      </ProtectedRoute>
    ),
    children: [
      {
        path: "finances",
        element: (
          <ProtectedRoute>
            <ParentFinancePortal />
          </ProtectedRoute>
        ),
      },
    ],
  },
];

export default parentRoutes;
